/*
 *
 * Homepage Api
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 02-Sep-2024
 */

import { axiosInstance as axios } from 'Api'
import { handlingResponse, openUrl, usePlainAxios } from 'Utility/globalMethods'
import appEnvRemap from 'Utility/appEnvRemap'
import { Capacitor } from '@capacitor/core'
import { getAuthProcessAsync } from 'Components/AcgFlow/AcgUtils'

if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/homepage/homepage')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}

export async function getLastTransactions (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/transaction-service/last-transactions',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getLastDocuments (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/document-service/last-documents',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getResults (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/get-results',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// export async function getServiceQuickLinks (params) {
//   let data

//   try {
//     data = await axios({
//       method: 'get',
//       url: '/services/merchant-service/home-page/widget',
//       data: { ...params }
//     })
//     return handlingResponse(data)
//   } catch (error) {
//     return handlingResponse(error)
//   }
// }
export async function getNavigationProfile (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/home-page/profile-tab/get-items',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getNavigationMenu (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/home-page/menu-tab/get-items',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getServicesCarousel (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/marketing-service/carousel-service-list?limit=5',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getDownload (params, contentType = 'application/pdf') {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/document-service/download',
      data: { ...params },
      headers: {
        Accept: contentType
      },
      responseType: 'arraybuffer'
    })

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getShops (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/xpay/shops',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getTerminals (params) {
  let data
  const shopId = params.shopId

  try {
    data = await axios({
      method: 'get',
      url: `/services/merchant-service/xpay/shops/${shopId}/terminals`
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getPromoNews (params) {
  const lang = params.lang
  const url = `/json-folder/promo-news/${lang}.jsonx`

  try {
    const data = await usePlainAxios({
      method: 'get',
      baseURL: `${process.env.CMS_URL}`,
      url,
      withCredentials: false
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method

export async function getUrlForXpay (params) {
  let data
  const terminalCode = params.terminalCode

  try {
    data = await axios({
      method: 'get',
      url: `/services/merchant-service/getUrlForXpay?terminalCode=${terminalCode}`,
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getUrlForCommerceWeb (params) {
  const tenant = params.tenant
  let data
  try {
    data = await axios({
      method: 'get',
      url: `/services/merchant-service/npg/chooseFlow/${tenant}`,
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getUrlForCommerceWebOld (params) {
  const tenant = params.tenant
  let data
  try {
    data = await axios({
      method: 'get',
      url: `/services/merchant-service/npg/ssoOld/${tenant}`,
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getUrlForCommerceWebSSO (params) {
  const { ssoURL, token } = params

  try {
    const url = `${ssoURL}/authentication/consume-token`

    let response = {}
    let responseData

    response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      credentials: 'include',
      body: `sso-token=${token}`
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const contentType = response.headers.get('content-type')

    // Verifica se la response ha contenuto e se è JSON
    if (contentType && contentType.includes('application/json')) {
      const text = await response.text()
      if (text) {
        try {
          responseData = JSON.parse(text)
        } catch (e) {
          responseData = { message: 'Invalid JSON response', rawText: text }
        }
      } else {
        responseData = { message: 'Empty JSON response' }
      }
    } else {
      // Se non è JSON, prendi il testo
      responseData = { message: await response.text() || 'Empty response' }
    }

    const data = {
      data: responseData,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers
    }

    return { error: null, response: data }
  } catch (error) {
    return {
      error: {
        message: error.message,
        status: error.status || 500
      },
      response: null
    }
  }
}

export async function getUrlForCommerceWebIAM (params) {
  const providerId = process.env.COMMERCE_WEB_PROVIDER_ID
  const tenant = params.tenant
  try {
    let data
    if (Capacitor.isNativePlatform()) {
      const clientId = process.env.CLIENT_ID
      const redirectUri = `${process.env.APPLICATION_URL}${process.env.PATH_LOGIN}`

      const payloadForGetAuth = await getAuthProcessAsync()

      const nonce = payloadForGetAuth.nonce
      const codeChallenge = payloadForGetAuth.codeChallenge

      data = await axios({
        method: 'get',
        url: `sso/authorize?response_type=code&scope=${process.env.SCOPE}&client_id=${clientId}&redirect_uri=${redirectUri}&nonce=${nonce}&code_challenge_method=S256&code_challenge=${codeChallenge}`,
        data: { ...params }
      })
      return handlingResponse({ ...data, codeVerifier: payloadForGetAuth.codeVerifier })
    } else {
      openUrl(`${appEnvRemap.API_NPG}/oauth2/sso-npg-federation?providerId=${providerId}&tenant=${tenant}`, true)
      return handlingResponse({ status: 200 })
    }
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function checkTransactionsTab (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/transaction-service/check-transactions-tab',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
